export const NAME = 'searchCore';
export const DISMISS_TIMER = 5000;
